import { keys } from './keys';

export const en = {
  [keys.title]:
    'This website only uses its own cookies for technical purposes and does not collect or share users’ personal data without their knowledge. However, it contains links to third-party websites with privacy policies, which you may choose to accept or not when accessing them.',
  [keys.linkLabel]: '<0>Cookie policy<0>',
  [keys.settings]: 'Settings for cookies',
  [keys.rejectAll]: 'Reject all',
  [keys.acceptAll]: 'Accept all',
  [keys.saveSettings]: 'Save',
  [keys.dialog.title]: 'Settings for cookies',
  [keys.dialog.description]:
    'Cookies are small text files that your browser places on your device to store certain information. By using the information that is stored and returned, a website can recognize that you have accessed and previously visited it using your device’s browser. We use this information to organize and display the website optimally according to your preferences. In this process, only the cookie itself is identified on your device. Personal data is only stored after your explicit consent or when it is absolutely necessary to enable the use of the service we provide and which you access.',
};
